import React, { Suspense, lazy } from "react";

// Route-level code splitting: public visitors only download the site chunk; admin/tools load their own chunk on demand.
export const PageFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center text-slate-400 text-xs tracking-[0.25em] uppercase" data-testid="chunk-loading">Loading…</div>
);

export const lazyPage = (loader, name) => {
  const C = lazy(name ? () => loader().then((m) => ({ default: m[name] })) : loader);
  return function LazyPage(props) {
    return <Suspense fallback={<PageFallback />}><C {...props} /></Suspense>;
  };
};
